import { getPeriodPerformance, getPeriodStat } from '@finect/front-resources/Products';
export var getPerformanceForPeriod = function getPerformanceForPeriod(stats, period, type) {
  var performance = getPeriodPerformance(stats, period, type);
  return performance ? performance.value : null;
};
export var getStatValueForPeriod = function getStatValueForPeriod(stats, period, stat) {
  var data = getPeriodStat(stats, period, stat);
  return data ? data.value : null;
};